import { useState } from "react";
import type { Product } from "@/lib/api";
import { formatCurrencyLabel } from "@/lib/site";

interface ProductCardProps {
  product: Product;
  onClick: () => void;
}

export const ProductCard = ({ product, onClick }: ProductCardProps) => {
  const [imgError, setImgError] = useState(false);
  const displayPrice = formatCurrencyLabel(product.price);

  return (
    <button
      onClick={onClick}
      className="group flex flex-col overflow-hidden rounded-lg border bg-card text-left card-hover focus:outline-none focus:ring-2 focus:ring-ring"
      aria-label={`Ver detalhes da oferta de ${product.item_name}`}
    >
      <div className="relative aspect-square overflow-hidden bg-muted">
        {product.image_url && !imgError ? (
          <img
            src={product.image_url}
            alt={product.item_name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="flex h-full items-center justify-center text-muted-foreground">
            <span className="px-3 text-center text-sm font-medium">Sem imagem</span>
          </div>
        )}

        {product.national ? (
          <span
            className="absolute left-1.5 top-1.5 inline-flex items-center rounded-full border border-emerald-200 bg-emerald-500/95 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-white shadow-sm"
            title="Produto nacional"
          >
            BR
          </span>
        ) : null}
      </div>

      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="line-clamp-2 text-sm font-medium leading-tight text-card-foreground">
          {product.item_name}
        </h3>
        {product.shop_name ? (
          <p className="line-clamp-1 text-xs text-muted-foreground">{product.shop_name}</p>
        ) : null}
        <div className="mt-auto pt-2">
          <span className="text-lg font-bold text-primary">{displayPrice}</span>
          {product.sales ? (
            <p className="text-xs text-muted-foreground">{product.sales} vendidos</p>
          ) : null}
          <p className="mt-2 text-xs font-semibold uppercase tracking-[0.14em] text-primary">
            Ver oferta
          </p>
        </div>
      </div>
    </button>
  );
};
